import { createFileRoute } from '@tanstack/react-router';
import { PlaceScreen } from '@/features/explore/PlaceScreen.tsx';
import { q } from '@/lib/queries.ts';

export const Route = createFileRoute('/_app/places/$idOrSlug')({
  validateSearch: (s: Record<string, unknown>): { review?: string } => (typeof s.review === 'string' ? { review: s.review } : {}),
  loader: ({ context, params }) => context.queryClient.prefetchQuery(q.place(params.idOrSlug)),
  component: PlaceRoute,
});

function PlaceRoute() {
  const { idOrSlug } = Route.useParams();
  const { review } = Route.useSearch();
  return <PlaceScreen idOrSlug={idOrSlug} focusReviewId={review} />;
}
